import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { PaginatedResponse, Pallet } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}
export class Pallets {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Pallet>> => {
    const response = await this.api.get('/logistics/pallets', config)
    return paginatedTransform(Pallet)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Pallet> => {
    const response = await this.api.get(`/logistics/pallets/${guid}`, config)
    return rawTransform(Pallet)(response.data)
  }

  export = async ({ fields , exportFilters}: ExportProps) => {
    const params = { fields: fields.join(','), stored: exportFilters?.stored }
    const response = await this.api.axiosInstance({
      url: '/logistics/pallets/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'pallets.csv')
  }
}
